module.exports = __webpack_public_path__ + "static/media/ai.34b8eb88.png";